import React, { FC } from 'react';

import { RichText } from '../RichText/RichText';

import Arrow40 from '../../assets/icons/ArrowRight40.svg';
import ArrowReturn from '../../assets/icons/ArrowReturn.svg';

import { createURLSlug } from '../../utils/createURLSlug';
import { RouterLink } from '../RouterLink/RouterLink';
import { Button } from '../Button/Button';

import * as styles from './Tiles.module.scss';

import { TilesProps } from './Tiles.types';

export const Tiles: FC<TilesProps> = ({ richTitle, subTitle, elements, buttonType, darkTheme }) => {
    return (
        <div className={styles.tilesContainer}>
            {richTitle && (
                <div className={styles.title}>
                    <RichText content={richTitle} textSize="heading3" />
                </div>
            )}
            {subTitle && (
                <div className={styles.subTitleContainer}>
                    <RichText content={subTitle} isTitle={true} titleWeight={'regular'} textSize="heading6" />
                </div>
            )}
            <div className={styles.squaresContainer}>
                {elements?.map((el, i) => {
                    let linkURL = '';
                    let translations: string[] | undefined;
                    if (el.linkMore) {
                        if ('pageReference' in el.linkMore && el.linkMore.pageReference) {
                            linkURL = `/${createURLSlug(el.linkMore.pageReference, el.linkMore.anchor)}`;
                            translations = el.linkMore.pageReference.translations;
                        } else if ('url' in el.linkMore && el.linkMore.url) {
                            linkURL = el.linkMore.url;
                        }
                    }

                    return (
                        <div key={i} className={styles.square}>
                            <div className={styles.squareItems}>
                                <div className={styles.squareTitleIconContainer}>
                                    <RichText content={el.richTitle} isTitle={true} textSize="heading4" />
                                    {elements.length - 1 === i ? (
                                        <div className={styles.arrowReturnContainer}>
                                            <ArrowReturn />
                                        </div>
                                    ) : (
                                        <div className={styles.arrowContainer}>
                                            <Arrow40 />
                                        </div>
                                    )}
                                </div>
                                <RichText
                                    content={el.singleColumnContent}
                                    titleWeight={'regular'}
                                    textSize={'heading6'}
                                />

                                {el.linkMore && (
                                    <div className={styles.linkLearnMoreContainer}>
                                        <RouterLink
                                            to={linkURL}
                                            translations={translations}
                                            className={styles.linkLearnMore}
                                        >
                                            <Button
                                                tag="span"
                                                variant={
                                                    buttonType === 'primary'
                                                        ? 'primarySmall'
                                                        : darkTheme
                                                        ? 'secondaryInverted'
                                                        : 'secondary'
                                                }
                                            >
                                                {el.linkMore.title}
                                            </Button>
                                        </RouterLink>
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
